import { useCallback, useState } from 'react';

// ==============================|| ESTADO QUE SOBREVIVE A LA NAVEGACIÓN ||============================== //
//
// Pedido del usuario (2026-10-27): "cuando entras a una obra al regresar se
// borran los filtros, necesitamos mantener esos filtros en esa navegación".
//
// Igual que useState, pero el valor se guarda en sessionStorage con una clave
// por pantalla: al volver a la lista (botón atrás o menú) se recupera tal como
// se dejó. sessionStorage es por PESTAÑA del navegador: otra pestaña empieza
// limpia y al cerrar la pestaña se olvida. Al cerrar sesión, al iniciarla y al
// emular a otro usuario se borra todo (limpiarEstadosSesion), para que los
// filtros de una persona no aparezcan en la pantalla de otra.
//
// Si el navegador bloquea el almacenamiento, funciona como un useState normal.

const PREFIJO = 'filtros:';

function leer<T>(clave: string, inicial: T): T {
  try {
    const v = sessionStorage.getItem(PREFIJO + clave);
    return v === null ? inicial : (JSON.parse(v) as T);
  } catch {
    return inicial;
  }
}

export function limpiarEstadosSesion(): void {
  try {
    Object.keys(sessionStorage).filter((k) => k.startsWith(PREFIJO)).forEach((k) => sessionStorage.removeItem(k));
  } catch {
    /* sin almacenamiento: nada que borrar */
  }
}

export default function useEstadoSesion<T>(clave: string, inicial: T): [T, (v: T | ((prev: T) => T)) => void] {
  const [valor, setValor] = useState<T>(() => leer(clave, inicial));

  const guardar = useCallback((v: T | ((prev: T) => T)) => {
    setValor((prev) => {
      const nuevo = typeof v === 'function' ? (v as (p: T) => T)(prev) : v;
      try { sessionStorage.setItem(PREFIJO + clave, JSON.stringify(nuevo)); } catch { /* sin almacenamiento */ }
      return nuevo;
    });
  }, [clave]);

  return [valor, guardar];
}
